import api from "./api";


export const get_all_testimonials = async() =>{
    const response = await api.get('/testimonials/');
    return response.data.data
}

export const create_testimonial = async (formData) =>{
   const response = await api.post('/testimonials', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
    
}

export const get_specific_testimonial = async (id) =>{
    const response = await api.get(`/testimonials/${id}`);
    return response.data;
}

export const update_testimonial = async (formData,id) =>{
    const response = await api.put(`/testimonials/${id}`,formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
});
    return response.data;
}


export const feedback_to_testimonial = async (id) =>{
    try{
        const response = await api.post(`/testimonials/feedback_to_testimonials`,id);
        return response.data;
    }
    catch(error){
        console.log("Error Happening => ", error)
        throw new Error(error?.response?.data?.detail)
    }
   
}